import { InjectionToken, Type } from '@angular/core';
import {
  IAnchorService,
  IAuthenticationService,
  IValidationService,
  ILayoutService,
  IPermissionService,
  IEnvironment,
  INavigationService,
  ILoadingService,
  IModalService,
  IStateService,
  IToastSettings,
  IMetaDataService,
  IAssetService,
  IToasterService,
  IInitService,
  IUserRoleService,
  IExcelService,
  ILoggingService,
  IPageToolbarConfig,
} from '../interfaces';
import { TViewItem, TViewMap } from './asset.types';

//#region Static File Tokens

export const ENVIRONMENT_TOKEN: InjectionToken<IEnvironment> =
  new InjectionToken('EnvironmentToken');

//#endregion

//#region Service Tokens

export const LOGGING_SERVICE_TOKEN: InjectionToken<ILoggingService> =
  new InjectionToken('LoggingServiceToken', {
    providedIn: 'root',
    factory: () => undefined,
  });

export const NAVIGATION_SERVICE_TOKEN: InjectionToken<INavigationService> =
  new InjectionToken('NavigationServiceToken', {
    providedIn: 'root',
    factory: () => undefined,
  });

export const LOADING_SERVICE_TOKEN: InjectionToken<ILoadingService> =
  new InjectionToken('LoadingServiceToken', {
    providedIn: 'root',
    factory: () => undefined,
  });

export const AUTHENTICATION_SERVICE_TOKEN: InjectionToken<IAuthenticationService> =
  new InjectionToken('AuthenticationServiceToken', {
    providedIn: 'root',
    factory: () => undefined,
  });

export const USER_ROLE_SERVICE_TOKEN: InjectionToken<
  IUserRoleService & IInitService
> = new InjectionToken('UserServiceToken', {
  providedIn: 'root',
  factory: () => undefined,
});

export const LAYOUT_SERVICE_TOKEN: InjectionToken<
  ILayoutService<
    unknown,
    unknown,
    TViewItem<unknown>,
    TViewMap<unknown, unknown>
  >
> = new InjectionToken('LayoutServiceToken', {
  providedIn: 'root',
  factory: () => undefined,
});

export const ANCHOR_SERVICE_TOKEN: InjectionToken<IAnchorService> =
  new InjectionToken('AnchorServiceToken', {
    providedIn: 'root',
    factory: () => undefined,
  });

export const PERMISSION_SERVICE_TOKEN: InjectionToken<IPermissionService> =
  new InjectionToken('PermissionServiceToken', {
    providedIn: 'root',
    factory: () => undefined,
  });

export const STATE_SERVICE_TOKEN: InjectionToken<IStateService> =
  new InjectionToken('StateServiceToken', {
    providedIn: 'root',
    factory: () => undefined,
  });

export const VALIDATION_SERVICE_TOKEN: InjectionToken<IValidationService> =
  new InjectionToken('ValidationServiceToken', {
    providedIn: 'root',
    factory: () => undefined,
  });

export const ASSETS_SERVICE_TOKEN: InjectionToken<
  IAssetService & IInitService
> = new InjectionToken('AssetsServiceToken', {
  providedIn: 'root',
  factory: () => undefined,
});

export const TOASTER_SERVICE_TOKEN: InjectionToken<IToasterService> =
  new InjectionToken('ToasterServiceToken', {
    providedIn: 'root',
    factory: () => undefined,
  });

export const MODAL_SERVICE_TOKEN: InjectionToken<IModalService> =
  new InjectionToken('ModalServiceToken', {
    providedIn: 'root',
    factory: () => undefined,
  });

export const METADATA_SERVICE_TOKEN: InjectionToken<IMetaDataService> =
  new InjectionToken('MetadataServiceToken', {
    providedIn: 'root',
    factory: () => undefined,
  });

export const EXCEL_SERVICE_TOKEN: InjectionToken<IExcelService> =
  new InjectionToken('ExcelServiceToken', {
    providedIn: 'root',
    factory: () => undefined,
  });

//#endregion

//#region Config Tokens

export const TOAST_CONFIG_TOKEN: InjectionToken<IToastSettings> =
  new InjectionToken('ToastConfigToken');

export const PAGE_TOOLBAR_CONFIG_TOKEN: InjectionToken<IPageToolbarConfig> =
  new InjectionToken('PageToolbarConfigToken');

//#endregion

// #region Miscellaneous Tokens

export const HAS_ROLE_DIRECTIVE_TOKEN: InjectionToken<Type<any>> =
  new InjectionToken('HasRoleDirectiveToken', {
    providedIn: 'root',
    factory: () => undefined,
  });

export const ASSETS_TOKEN: InjectionToken<object> = new InjectionToken(
  'AssetsToken',
  {
    providedIn: 'root',
    factory: () => undefined,
  },
);

export const VIEW_MAP_TOKEN: InjectionToken<TViewMap<unknown, unknown>> =
  new InjectionToken('viewMapToken', {
    providedIn: 'root',
    factory: () => undefined,
  });

export const MODAL_PERMISSION_TOKEN: InjectionToken<Type<any>> =
  new InjectionToken('ModalPermissionToken', {
    providedIn: 'root',
    factory: () => undefined,
  });

export const INPUT_DIRECTIVE_TOKEN: InjectionToken<Type<any>> =
  new InjectionToken('InputDirectiveToken', {
    providedIn: 'root',
    factory: () => undefined,
  });
// #endregion
